import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	selectedVersionId: null,
};

const costTrackingSlice = createSlice({
	name: "costTracking",
	initialState,
	reducers: {
		setSelectedVersion: (state, action) => {
			state.selectedVersionId = action.payload ?? null;
		},
	},
});

export const { setSelectedVersion } = costTrackingSlice.actions;

export const selectSelectedVersionId = (state) =>
	state.costTracking.selectedVersionId;

export default costTrackingSlice.reducer;
